import { register } from "async-ops";
import { getDefaultOptions } from "../fetch";
import { callMvcApi } from "../../call-web-api";
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE';


export const service = async (data) => {
  const options: object = {
    url:  '/api/utility/UpdateUserPreference',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(UPDATE_PREFERENCE, service, mock);
